<div [ngClass]="getClassNames('switchRow')">

  <ng-template #defaultArrowIcon>
    <i [ngClass]="getClassNames('arrowIcon')"></i>
  </ng-template>

  <a *ngIf="allowCollapse" (click)="toggleCollapse()" [ngClass]="getClassNames('arrowIconButton', data.collapsed ? 'collapsed' : null)">
    <ng-container *ngIf="getArrowIconTemplate() as template; else defaultArrowIcon">
      <ng-container *ngTemplateOutlet="template; context: getArrowIconContext()"></ng-container>
    </ng-container>
  </a>

  <ng-container *ngIf="getButtonGroupTemplate() as template; else defaultButtonGroup">
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      <ng-container *ngTemplateOutlet="template; context: getButtonGroupContext()"></ng-container>
    </div>
  </ng-container>

  <ng-template #defaultButtonGroup>
    <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
      
      <button type="button" *ngIf="showPropertyButton(data)" (click)="addRule()" [ngClass]="getClassNames('button')" [disabled]=disabled>
        <i [ngClass]="getClassNames('addIcon')"></i> Property
      </button>

      <button type="button" (click)="addRuleSet()" [ngClass]="getClassNames('button')" *ngIf="!hideRuleSet" [disabled]=disabled>
        <i [ngClass]="getClassNames('addIcon')"></i> Ruleset
      </button>

      <ng-container *ngIf="!!parentValue">
        <button type="button" (click)="removeRuleSet()" [ngClass]="getClassNames('button', 'removeButton')" [disabled]=disabled>
          <i [ngClass]="getClassNames('removeIcon')"></i>
        </button>
      </ng-container>
      
    </div>
  </ng-template>

  <ng-container *ngIf="getSwitchGroupTemplate() as template; else defaultSwitchGroup">
    <ng-container *ngTemplateOutlet="template; context: getSwitchGroupContext()"></ng-container>
  </ng-container>

  <ng-template #defaultSwitchGroup>
    <div [ngClass]="getClassNames('switchGroup', 'transition')" *ngIf="data">
      <div [ngClass]="getClassNames('switchControl')" *ngIf="data.dataType == 'Condition' || data.dataType == 'AppliesTo'" >
        <input type="radio" [ngClass]="getClassNames('switchRadio')" [(ngModel)]="data.condition" [disabled]=disabled
          value="and" #andOption />
        <label (click)="changeCondition(andOption.value)" [ngClass]="getClassNames('switchLabel')">AND</label>
      </div>
      <div [ngClass]="getClassNames('switchControl')" *ngIf="data.dataType == 'Condition' || data.dataType == 'AppliesTo'">
        <input type="radio" [ngClass]="getClassNames('switchRadio')" [(ngModel)]="data.condition" [disabled]=disabled
          value="or" #orOption />
        <label (click)="changeCondition(orOption.value)" [ngClass]="getClassNames('switchLabel')" style="margin-right:1rem">OR</label>
      </div>
      <div>
        <select [(ngModel)]="data.dataType" [ngClass]="getClassNames('entityControl')" (change)="changeDataType(dataType.value)" #dataType>
          <option *ngFor="let d of getDataType(data.dataType,parentValue)" [value]='d'>{{ d }}</option>
        </select>
      </div>
    </div>
  </ng-template>

</div>

<div #treeContainer (transitionend)="transitionEnd($event)" [ngClass]="getClassNames('treeContainer', data.collapsed ? 'collapsed' : null)">

  <ul [ngClass]="getClassNames('tree')" *ngIf="data && data.rules">
    <ng-container *ngIf="data.dataType">
      <ng-container *ngFor="let rule of data.rules;let i=index">
        <ng-container *ngIf="{ruleset: rule.rules, invalid: !config.allowEmptyRulesets && rule.rules && rule.rules.length === 0} as local">
          <li [ngClass]="getQueryItemClassName(local)">

            <!-- Condition rules   -->
            <ng-container *ngIf="!local.ruleset && (data.dataType === 'Condition' || data.dataType === 'AppliesTo')">
  
              <ng-container *ngIf="getRemoveButtonTemplate() as template; else defaultRemoveButton2">
                <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
                  <ng-container *ngTemplateOutlet="template; context: getRemoveButtonContext(rule)"></ng-container>
                </div>
              </ng-container>
  
              <!-- Remove Rule Button -->
              <ng-template #defaultRemoveButton2>
                <div [ngClass]="getClassNames('removeButtonSize', 'rightAlign')">

                  <button *ngIf="RuleType == 'Validation'" type="button" [ngClass]="getClassNames('button')" (click)="addRuleProperty(rule)" [disabled]=disabled>
                    <i [ngClass]="getClassNames('addIcon')"></i> Add Property
                  </button>

                  <button type="button" [ngClass]="getClassNames('button', 'removeButton')" (click)="removeRule(rule, data)" [disabled]=disabled>
                    <i [ngClass]="getClassNames('removeIcon')"></i>
                  </button>
                </div>
              </ng-template>
  
              <div *ngIf="configEntities?.length > 0" class="q-inline-block-display">
                <ng-container *ngIf="getEntityTemplate() as template; else defaultEntity2">
                  <ng-container *ngTemplateOutlet="template; context: getEntityContext(rule)"></ng-container>
                </ng-container>
              </div>
  
              <ng-template #defaultEntity2>
                <div [ngClass]="getClassNames('entityControlSize')">
                  <select [ngClass]="getClassNames('entityControl')" [(ngModel)]="rule.entity" (ngModelChange)="changeEntity2($event, rule,i,data)"
                    [disabled]="disabled">
                    <option *ngFor="let entity of configEntities" [ngValue]="entity.value">
                      {{entity.name}}
                    </option>
                  </select>
                </div>
              </ng-template>
  
              <ng-container *ngIf="getFieldTemplate() as template; else defaultField2">
                <ng-container *ngTemplateOutlet="template; context: getFieldContext(rule)"></ng-container>
              </ng-container>
  
  
              <ng-template #defaultField2>
                <div [ngClass]="getClassNames('fieldControlSize')">
                  <select *ngIf="rule.entity != 'chargeProfile'" [ngClass]="getClassNames('fieldControl')" [(ngModel)]="rule.field" (ngModelChange)="changeField2($event)" [disabled]="disabled">
                    <option [ngValue]=""></option>
                    <option *ngFor="let field of getFields3(rule.entity)" [ngValue]="field.value">
                      {{field.name}}
                    </option>
                  </select>

                  <input  *ngIf="rule.entity == 'chargeProfile'" [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.field" [disabled]="disabled" type="text">

                  <!-- <ng-select  [(ngModel)]="rule.field" (ngModelChange)="atals($event)" [disabled]="disabled" [addTag]="addTagFn" [virtualScroll]="false" class="q-dropdown-rule no-line">
                    <ng-option *ngFor="let field of getFields3(rule.entity)" [value]="field.value">{{field.name}}</ng-option>
                 </ng-select> -->

                </div>
              </ng-template>
  
  
              <ng-container *ngIf="getOperatorTemplate() as template; else defaultOperator2">
                <ng-container *ngTemplateOutlet="template; context: getOperatorContext(rule)"></ng-container>
              </ng-container>
  
              <ng-template #defaultOperator2>
                <div [ngClass]="getClassNames('operatorControlSize')">
                  
                  <select [ngClass]="getClassNames('operatorControl')" [(ngModel)]="rule.operator" (ngModelChange)="changeOperator(rule)"
                    [disabled]="disabled">
                    <option *ngFor="let operator of getOperators2(rule.field)" [ngValue]="operator">
                      {{operator}}
                    </option>
                  </select>
                </div>
              </ng-template>
  
              <ng-container *ngIf="findTemplateForRule2(rule) as template; else defaultInput2">
                <ng-container *ngTemplateOutlet="template; context: getInputContext(rule)"></ng-container>
              </ng-container>
  
              <ng-template #defaultInput2>
                
                <div [ngClass]="getClassNames('inputControlSize')" [ngSwitch]="getInputType2(rule.field, rule.operator, rule)">
                  
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                  [disabled]="disabled" *ngSwitchCase="'boolean'" type="checkbox">
                  
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'string'" type="text">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'number'" type="number">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'date'" type="date">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'time'" type="time">

                  <!-- (scrollToEnd)="fetchMoreData(rule)" -->

                 <ng-select 
                  *ngSwitchCase="'category'" 
                  [searchWhileComposing]="true" 
                  [addTag]="addTagFn" 
                  [clearable]="true"
                  (search)="execKeypress($event,rule.field)" 
                  [searchable]="true" 
                  [multiple]="true" 
                  [clearSearchOnAdd]="true" 
                  [loading]="loading"
                  [virtualScroll]="true"
                  (ngModelChange)="changeInput()"
                  [(ngModel)]="rule.value" 
                  class="q-dropdown-rule">
                      <ng-option *ngFor="let opt of getOptions2(rule.field, rule)" [value]="opt.value">{{opt.name}}</ng-option>
                  </ng-select>

                  <ng-select *ngSwitchCase="'category-not-multiple'" 
                    [searchWhileComposing]="true" 
                    (search)="execKeypress($event,rule.field)" 
                    [searchable]="true" 
                    [multiple]="false" 
                    [clearSearchOnAdd]="true" 
                    [loading]="loading" 
                    [virtualScroll]="true" 
                    (ngModelChange)="changeInput()"
                    [(ngModel)]="rule.value" class="q-dropdown-rule q-dropdown-rule-category-special">
                      <ng-option *ngFor="let opt of getOptions2(rule.field)" [value]="opt.value">{{opt.name}}</ng-option>
                  </ng-select>

                  <ng-container *ngSwitchCase="'multiselect'">
                    <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                      [disabled]="disabled" multiple>
                      <option *ngFor="let opt of getOptions2(rule.field)" [ngValue]="opt.value">{{opt.name}}</option>
                    </select>
                  </ng-container>
                  
              
                </div>
              </ng-template>

              <ng-container *ngIf="rule"  >
                <div #treeContainer (transitionend)="transitionEnd($event)" [ngClass]="getClassNames('treeContainer', data.collapsed ? 'collapsed' : null)">
                  <ul [ngClass]="getClassNames('tree')">
                    <ng-container *ngIf="rule?.compare?.length > 0">
                        <ng-container *ngFor="let compare of rule?.compare;let i = index">

                          <ng-container>
                            <div [ngClass]="getClassNames('entityControlSize')">                     
                              <select [ngClass]="getClassNames('entityControl')" [(ngModel)]="compare.entity" (ngModelChange)="changeCompareEntity($event, compare,i,data)"
                                [disabled]="disabled">
                                <option *ngFor="let entity of configEntities" [ngValue]="entity.value">
                                  {{entity.name}}
                                </option>
                              </select>
                            </div>
                          </ng-container>

                          <ng-container>
                            <div [ngClass]="getClassNames('fieldControlSize')">
                              <select *ngIf="compare.entity != 'chargeProfile'" [ngClass]="getClassNames('fieldControl')" [(ngModel)]="compare.field" (ngModelChange)="changeCompareField($event)" [disabled]="disabled">
                                <option [ngValue]=""></option>
                                <option *ngFor="let field of getFields3(compare.entity)" [ngValue]="field.value">
                                  {{field.name}}
                                </option>
                              </select>
            
                              <input  *ngIf="compare.entity == 'chargeProfile'" [ngClass]="getClassNames('inputControl')" [(ngModel)]="compare.field" [disabled]="disabled" type="text">
            
                              <!-- <ng-select  [(ngModel)]="rule.field" (ngModelChange)="atals($event)" [disabled]="disabled" [addTag]="addTagFn" [virtualScroll]="false" class="q-dropdown-rule no-line">
                                <ng-option *ngFor="let field of getFields3(rule.entity)" [value]="field.value">{{field.name}}</ng-option>
                             </ng-select> -->
            
                            </div>
                          </ng-container>

                        </ng-container>
                    </ng-container>
                  </ul>
                </div>
              </ng-container>
              
            </ng-container>


            <!-- Properties Rules -->
            <ng-container *ngIf="!local.ruleset && (data.dataType !== 'Condition' && data.dataType !== 'AppliesTo')">        

              <ng-container *ngIf="getRemoveButtonTemplate() as template; else defaultRemoveButton">
                <div [ngClass]="getClassNames('buttonGroup', 'rightAlign')">
                  <ng-container *ngTemplateOutlet="template; context: getRemoveButtonContext(rule)"></ng-container>
                </div>
              </ng-container>
  
              <ng-template #defaultRemoveButton>
                <div [ngClass]="getClassNames('removeButtonSize', 'rightAlign')">
                  <button type="button" [ngClass]="getClassNames('button', 'removeButton')" (click)="removeRule(rule, data)" [disabled]=disabled>
                    <i [ngClass]="getClassNames('removeIcon')"></i>
                  </button>
                </div>
              </ng-template>
  
              <div *ngIf="entities?.length > 0" class="q-inline-block-display">
                <ng-container *ngIf="getEntityTemplate() as template; else defaultEntity">
                  <ng-container *ngTemplateOutlet="template; context: getEntityContext(rule)"></ng-container>
                </ng-container>
              </div>
  
              <ng-template #defaultEntity>
                <div [ngClass]="getClassNames('entityControlSize')">
                  <select [ngClass]="getClassNames('entityControl')" [(ngModel)]="rule.entity" (ngModelChange)="changeEntity($event, rule,i,data)"
                    [disabled]="disabled">
                    <option *ngFor="let entity of entities" [ngValue]="entity.value">
                      {{entity.name}}
                    </option>
                  </select>
                </div>
              </ng-template>
  
              <ng-container *ngIf="getFieldTemplate() as template; else defaultField">
                <ng-container *ngTemplateOutlet="template; context: getFieldContext(rule)"></ng-container>
              </ng-container>
  
  
              <ng-template #defaultField>
                <div [ngClass]="getClassNames('fieldControlSize')">
                  <select [ngClass]="getClassNames('fieldControl')" [(ngModel)]="rule.field" (ngModelChange)="changeField3(rule)"
                    [disabled]="disabled">
                    <option *ngFor="let field of getFields2(data.dataType)" [ngValue]="field">
                      {{field}}
                    </option>
                  </select>
                </div>
              </ng-template>
  
              <ng-container *ngIf="getOperatorTemplate() as template; else defaultOperator">
                <ng-container *ngTemplateOutlet="template; context: getOperatorContext(rule)"></ng-container>
              </ng-container>
  
              <ng-template #defaultOperator>
                <div [ngClass]="getClassNames('operatorControlSize')">
                  <select [ngClass]="getClassNames('operatorControl')" [(ngModel)]="rule.operator" (ngModelChange)="changeOperator(rule)"
                    [disabled]="disabled">
                    <option *ngFor="let operator of getOperators(rule.field)" [ngValue]="operator">
                      {{operator}}
                    </option>
                  </select>
                </div>
              </ng-template>
  
              <ng-container *ngIf="findTemplateForRule(rule) as template; else defaultInput">
                <ng-container *ngTemplateOutlet="template; context: getInputContext(rule)"></ng-container>
              </ng-container>
  
              <ng-template #defaultInput>
                <div [ngClass]="getClassNames('inputControlSize')" [ngSwitch]="getInputType(rule.field, rule.operator)">

                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                  [disabled]="disabled" *ngSwitchCase="'boolean'" type="checkbox">

                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'string'" type="text">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'number'" type="number">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'date'" type="date">
                  <input [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput()"
                    [disabled]="disabled" *ngSwitchCase="'time'" type="time">
                 
                  <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="changeInput(rule)"
                    [disabled]="disabled" *ngSwitchCase="'category'">
                    <option *ngFor="let opt of getOptions(rule.field)" [ngValue]="opt.value">
                      {{opt.name}} 
                    </option>
                  </select>

                  <ng-container *ngSwitchCase="'multiselect'">
                    <select [ngClass]="getClassNames('inputControl')" [(ngModel)]="rule.value" (ngModelChange)="fetchMoreData(rule)"
                      [disabled]="disabled" multiple>
                      <option *ngFor="let opt of getOptions(rule.field)" [ngValue]="opt.value">
                        {{opt.name}}
                      </option>
                    </select>
                  </ng-container>
                
                </div>
              </ng-template>  
            </ng-container>

            <query-builder 
              *ngIf="local.ruleset" 
              [data]="rule" 
              [disabled]="disabled" 
              [RuleType]="RuleType"
              [parentTouchedCallback]="parentTouchedCallback || onTouchedCallback"
              [parentChangeCallback]="parentChangeCallback || onChangeCallback" 
              [parentInputTemplates]="parentInputTemplates || inputTemplates"
              [parentOperatorTemplate]="parentOperatorTemplate || operatorTemplate" 
              [parentFieldTemplate]="parentFieldTemplate || fieldTemplate"
              [parentEntityTemplate]="parentEntityTemplate || entityTemplate" 
              [parentSwitchGroupTemplate]="parentSwitchGroupTemplate || switchGroupTemplate"
              [parentButtonGroupTemplate]="parentButtonGroupTemplate || buttonGroupTemplate" 
              [parentRemoveButtonTemplate]="parentRemoveButtonTemplate || removeButtonTemplate"
              [parentEmptyWarningTemplate]="parentEmptyWarningTemplate || emptyWarningTemplate" 
              [parentArrowIconTemplate]="parentArrowIconTemplate || arrowIconTemplate"
              [parentValue]="data" 
              [classNames]="classNames" 
              [config]="config" 
              [DataTypeBuilder]="DataTypeBuilder" 
              [DataTypeChildren]="DataTypeChildren" 
              [DataTypeParent]="DataTypeParent" 
              [allowRuleset]="allowRuleset"
              [allowCollapse]="allowCollapse" 
              [emptyMessage]="emptyMessage" 
              [operatorMap]="operatorMap" >
            </query-builder>
            
            
  
  
            <ng-template #defaultEmptyWarning>
              <p [ngClass]="getClassNames('emptyWarning')" *ngIf="local.invalid">
                {{emptyMessage}}
              </p>
            </ng-template>
          </li>
        </ng-container>

        
      </ng-container>
    </ng-container>
  </ul>
</div>